
export default {
    name: 'LeeOption',
    inheritAttrs: false,
    data() {
        return {}
    },
    inject: ['select'],
    computed: {
        have() {
            if (this.select.filterable) {
                var search = this.select.search.toLowerCase()
                return this.label.toLowerCase().indexOf(search) > -1
            }
            return true
        },
        haveslot() {
            return this.$slots.default
        }
    },
    methods: {
        sel(value) {
            this.select.exp = false
            this.select.$emit('input', value)
        }
    },
    props: {
        value: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        }
    }
};
